module.exports = i18next;


//////////////////
// WEBPACK FOOTER
// external "i18next"
// module id = 8
// module chunks = 1